module.exports = __webpack_public_path__ + "static/media/logo-yahoo.1738d03e.svg";